import React from "react";
import { Button } from "../atom/Button";
import { useNavigate } from "react-router-dom";

export const Overview = () => {
  const navigate = useNavigate();

  return (
    <div className="relative flex items-center justify-between p-6 bg-gradient-to-r from-gray-50 to-white border-b border-gray-200 overflow-hidden">
      <div className="absolute top-0 left-0 w-64 h-64 bg-yellow-100 rounded-full filter blur-3xl opacity-20 -translate-x-32 -translate-y-32"></div>
      <div className="absolute bottom-0 right-0 w-48 h-48 bg-yellow-200 rounded-full filter blur-3xl opacity-20 translate-x-24 translate-y-24"></div>
      
      <div className="relative z-10 flex items-center space-x-4">
        <div className="w-1 h-12 bg-gradient-to-b from-yellow-400 to-yellow-600 rounded-full"></div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
            Overview
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Track and manage all your recruitment metrics
          </p>
        </div>
      </div>
      
      <div className="relative z-10">
        <Button 
          label="New Request" 
          onClick={() => navigate("/recruitment")}
          className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5 active:scale-95"
        />
      </div>
    </div>
  );
};